import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import VSelect from 'vue-select'
import Toasted from 'vue-toasted'
import VCalendar from 'v-calendar'
import VModal from 'vue-js-modal'
import VueI18n from 'vue-i18n'
import Draggable from 'vuedraggable'
import VueTippy, { TippyComponent } from 'vue-tippy'
import VueTextareaAutosize from 'vue-textarea-autosize'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
import Nl2br from 'vue-nl2br'
import VueScrollTo from 'vue-scrollto'


// Plugins
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(VueI18n)
Vue.use(VueClipboard)
Vue.use(Toasted)
Vue.use(VCalendar)
Vue.use(BootstrapVue)
Vue.use(VueTippy)
Vue.use(VueScrollTo)
Vue.use(VueTextareaAutosize)
Vue.use(VModal, { dynamic: true })


// Components
Vue.component('nl2br', Nl2br)
Vue.component('draggable', Draggable);
Vue.component('v-select', VSelect);
Vue.component("tippy", TippyComponent);
Vue.component('loader', require('@back.components/Loader').default);
Vue.component('loading-button', require('@back.components/form/LoadingButton').default);
Vue.component('modal', require('@components/Modal').default);
Vue.component('card', require('@components/Card').default);
Vue.component('app-header', require('@partials/Header').default);
Vue.component('app-footer', require('@partials/Footer').default);
Vue.component('list-group-item', require('@components/list/GroupItem').default);
Vue.component('flag', require('@back.components/Flag').default);

// Form
Vue.component('form-component', require('@components/forms/Form').default);
Vue.component('form-progress', require('@components/forms/partials/Progress').default);
Vue.component('form-row', require('@components/forms/partials/Row').default);
Vue.component('form-section', require('@components/forms/partials/Section').default);

// Form elements
Vue.component('form-label', require('@components/form-elements/Label').default);
Vue.component('form-errors', require('@components/form-elements/Errors').default);
Vue.component('input-group', require('@components/form-elements/InputGroup').default);
Vue.component('input-text', require('@components/form-elements/InputText').default);
Vue.component('input-textarea', require('@components/form-elements/InputTextarea').default);
Vue.component('input-date', require('@components/form-elements/InputDate').default);
Vue.component('input-select', require('@components/form-elements/InputSelect').default);
Vue.component('input-radio', require('@components/form-elements/InputRadio').default);
Vue.component('input-checkbox', require('@components/form-elements/InputCheckbox').default);
Vue.component('input-place', require('@components/form-elements/InputPlace').default);

// Booking
Vue.component('booking-modal', require('@components/booking/Modal').default);
Vue.component('booking-alert', require('@components/booking/Alert').default);
Vue.component('mission-messenger', require('@components/mission/Messenger').default);
Vue.component('client-messenger', require('@components/client/Messenger').default);
Vue.component('messenger-medias', require('@back.components/messenger/Medias').default);

// Chart
Vue.component('line-chart', require('@components/charts/Line').default);
Vue.component('bar-chart', require('@components/charts/Bar').default);
Vue.component('pie-chart', require('@components/charts/Pie').default);
Vue.component('doughnut-chart', require('@components/charts/Doughnut').default);
Vue.component('polar-area-chart', require('@components/charts/PolarArea').default);

// VSelect
VSelect.props.components.default = () => ({
	Deselect: {
		render: createElement => createElement('i', {class: 'bi bi-x'})
	},
	OpenIndicator: {
		render: createElement => createElement('i', {class: 'bi bi-chevron-down'})
	}
});


// Flash

Vue.prototype.$flash = function(payload) {
    setTimeout(() => {
        this.$toasted.show(payload, {
            position: 'bottom-right',
            duration: 2500
        })
    }, 400)
}